module.exports = __webpack_public_path__ + "static/media/Nuzleaf_gaussian2.331f1315.png";